import { render } from "./BaseInfiniteTable.vue?vue&type=template&id=a6354b8a&scoped=true"
import script from "./BaseInfiniteTable.vue?vue&type=script&lang=js"
export * from "./BaseInfiniteTable.vue?vue&type=script&lang=js"

import "./BaseInfiniteTable.vue?vue&type=style&index=0&id=a6354b8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6354b8a"]])

export default __exports__